import React from 'react';
import './Premium.css';

const PremiumSuccess = () => (
  <div className="pr">
    <header className="pr-masthead">
      <a href="/" className="pr-brand">
        <img src="/icons/icon-128.webp" alt="" width="32" height="32" />
        <span className="dd-serif">DeepDime</span>
      </a>
    </header>
    <main className="pr-main">
      <div className="pr-hero">
        <div className="dd-eyebrow">Pro is active</div>
        <h1 className="dd-serif">Thank you. Your note just got the full risk figures.</h1>
        <p className="dd-muted">Sign in again if the app still shows the free plan; the upgrade is applied to your account within a minute of payment.</p>
        <div className="pr-cta">
          <a href="/portfolio" className="dd-btn pr-btn">Open my portfolio note</a>
        </div>
      </div>
    </main>
    <footer className="pr-footer dd-mono dd-muted">DeepDime · Analysis, not financial advice.</footer>
  </div>
);

export default PremiumSuccess;
